document.addEventListener('DOMContentLoaded', function () {
  /*
    FIX: un mesaj vechi de eroare ramasese "prins" in #cart-errors
    dintr-o sesiune anterioara (probabil de la actualizari rapide,
    consecutive) si nu mai era curatat automat de Dawn la incarcarea
    paginii. Il golim explicit, o singura data, la fiecare incarcare.
  */
  var cartErrorsEl = document.getElementById('cart-errors');
  if (cartErrorsEl) cartErrorsEl.textContent = '';

  function addQtyDisplay(input) {
    try {
      if (!input || input.dataset.fcQtyDisplayed) return;
      input.dataset.fcQtyDisplayed = 'true';

      var display = document.createElement('span');
      display.className = 'fc-qty-display';
      display.textContent = input.value;
      input.insertAdjacentElement('afterend', display);

      input.addEventListener('input', function () { display.textContent = input.value; });
      input.addEventListener('change', function () { display.textContent = input.value; });
    } catch (e) {
      /*
        FIX: orice eroare aici era propagata mai departe si intrerupea
        procesul intern al Dawn de actualizare a cosului, provocand
        mesajul fals "There was an error while updating your cart" -
        chiar daca actualizarea reala reusise perfect pe server.
        Acum, orice problema aici ramane izolata, fara sa afecteze
        restul paginii.
      */
    }
  }

  function enhanceAll() {
    try {
      document.querySelectorAll('.fc-cart-items input.quantity__input').forEach(addQtyDisplay);
    } catch (e) {}
  }

  enhanceAll();

  var container = document.getElementById('main-cart-items');
  if (container) {
    var observer = new MutationObserver(function () {
      enhanceAll();
    });
    observer.observe(container, { childList: true, subtree: true });
  }
});